module.exports = __webpack_public_path__ + "assets/867c9642c21a88420cd49a43104b1367.mp3";